
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class SignUpIntro extends Vue {
  @Prop() public next!: any;
  //data
  isCheck = false;
}
